import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { PaymentOptionTypeToProviderMap, } from '@debbie/common/dist/collectors/index.js';
import * as paymentMethodsAPI from '@debbie/cortex/dist/api/payment-methods.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import Checkbox from '../../Checkbox.js';
import Button from '../../Button.js';
import Modal from '../../Modal.js';
import MoneyInput from '../../MoneyInput.js';
import card_dan from '../../../assets/images/card_dan.png';
import card_master from '../../../assets/images/card_master.png';
import card_visa from '../../../assets/images/card_visa.png';
import mobilepay from '../../../assets/images/mobilepay.png';
import vipps from '../../../assets/images/vipps.png';
import swish from '../../../assets/images/swish.png';
import payment_bs from '../../../assets/images/payment_bs.png';
import payment_ls from '../../../assets/images/payment_ls.png';
const PaymentOptionView = (props) => {
    const { case: _case, paymentOption, caseVouchers, collector } = props;
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const [businesstermsAccepted, setBusinesstermsAccepted] = useState(!collector.businessTerms);
    const [partialPaymentModalOpen, setPartialPaymentModalOpen] = useState(false);
    const [amount, setAmount] = useState(caseVouchers
        ? Math.round(-helpers.overview.balance(caseVouchers) / 2)
        : null);
    return (React.createElement("div", null,
        collector.businessTerms && (React.createElement("p", { style: { fontSize: '.8em' } },
            React.createElement(Checkbox, { value: businesstermsAccepted, onChange: (e) => setBusinesstermsAccepted(e.target.checked), placeholder: React.createElement("span", null,
                    lang.debtorWebHome.iApprove,
                    ' ',
                    React.createElement("a", { target: "_blank", href: collector.businessTerms, rel: "noreferrer" }, lang.debtorWebHome.theBusinessTerms)) }))),
        React.createElement(PaymentButton, { caseVouchers: caseVouchers, _case: _case, businesstermsAccepted: businesstermsAccepted, amount: null, provider: PaymentOptionTypeToProviderMap[paymentOption.type], paymentOption: paymentOption }),
        !tenant?.settings?.debtorweb?.noPartialPayments && (React.createElement("p", { style: {
                cursor: 'pointer',
                fontWeight: '900',
                textAlign: 'center',
                fontSize: '0.7em',
                opacity: '0.6',
                marginTop: '1.5em',
            }, onClick: () => {
                if (!businesstermsAccepted) {
                    alert(lang.debtorWebHome.pleaseAcceptBusinessTerms);
                    return;
                }
                setPartialPaymentModalOpen(!partialPaymentModalOpen);
            } }, lang.debtorWebHome.partialPayment)),
        React.createElement(CardIcons, { paymentOption: paymentOption }),
        partialPaymentModalOpen && (React.createElement(Modal, { header: lang.debtorWebHome.partialPayment, onToggle: () => setPartialPaymentModalOpen(!partialPaymentModalOpen), maxWidth: "500px" },
            React.createElement(MoneyInput, { value: amount, allowNull: true, min: 0, max: -helpers.overview.balance(caseVouchers), placeholder: lang.paymentPlans.amount, onChange: setAmount }),
            React.createElement(PaymentButton, { caseVouchers: caseVouchers, _case: _case, businesstermsAccepted: businesstermsAccepted, amount: amount, provider: PaymentOptionTypeToProviderMap[paymentOption.type], paymentOption: paymentOption })))));
};
export default PaymentOptionView;
const Card = styled.img `
  margin: 0 6px;
  height: 25px;
`;
const PaymentButton = (props) => {
    const { caseVouchers, businesstermsAccepted, _case, amount, provider, paymentOption, } = props;
    const lang = useSelector((s) => s.lang);
    const [loading, setLoading] = useState(false);
    const amountValid = amount === null || amount > 1000;
    return (React.createElement(Button, { block: true, style: { fontSize: '.7em' }, size: "small", theme: "secondary", disabled: (caseVouchers && -helpers.overview.balance(caseVouchers) < 100) ||
            !amountValid, loading: loading, onClick: async () => {
            if (!businesstermsAccepted) {
                alert(lang.debtorWebHome.pleaseAcceptBusinessTerms);
                return;
            }
            setLoading(true);
            try {
                const portal = await paymentMethodsAPI.getPaymentPortal(provider, paymentOption.id, _case.caseId, amount, `${window.location.href}/paid`, `${window.location.href}`);
                window.location.replace(portal.url);
            }
            catch (error) {
                alert('Error. Please try again later.');
                console.error(error);
            }
            setLoading(false);
        } }, props.partialPayment
        ? lang.debtorWebHome.partialPayment
        : lang.debtorWebPaymentPlans.pay));
};
export const CardIcons = (props) => {
    const { paymentOption } = props;
    return (React.createElement("p", { style: {
            textAlign: 'center',
            marginTop: '15px',
        } },
        // @ts-ignore
        paymentOption?.details?.visa && React.createElement(Card, { src: card_visa }),
        // @ts-ignore
        paymentOption?.details?.mastercard && React.createElement(Card, { src: card_master }),
        // @ts-ignore
        paymentOption?.details?.dankort && React.createElement(Card, { src: card_dan }),
        // @ts-ignore
        paymentOption?.details?.mobilepay && React.createElement(Card, { src: mobilepay }),
        // @ts-ignore
        paymentOption?.details?.vipps && React.createElement(Card, { src: vipps }),
        // @ts-ignore
        paymentOption?.details?.swish && React.createElement(Card, { src: swish }),
        // @ts-ignore
        paymentOption?.details?.betalingsservice && React.createElement(Card, { src: payment_bs }),
        // @ts-ignore
        paymentOption?.details?.leverandorservice && React.createElement(Card, { src: payment_ls })));
};
//# sourceMappingURL=PaymentPortal.js.map